import React from 'react';
import {
  Box,
  Container,
  Button,
  Typography,
  Paper,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { CheckCircle, Login, Home, EventNote } from '@mui/icons-material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContextNew';

const OfflinePaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const { isAuthenticated } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0d4f3c 0%, #0a3d2e 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        py: 4
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={24}
          sx={{
            p: { xs: 3, sm: 4 },
            borderRadius: 3,
            textAlign: 'center'
          }}
        >
          <Box
            sx={{
              width: 88,
              height: 88,
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 2
            }}
          >
            <CheckCircle sx={{ fontSize: 52, color: 'white' }} />
          </Box>
          <Typography variant={isMobile ? 'h5' : 'h4'} component="h1" gutterBottom fontWeight={700}>
            Payment received
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 2 }}>
            Thank you. Your payment was successful. Your booking will show as paid shortly — you can close this page.
          </Typography>
          {sessionId && (
            <Typography variant="caption" display="block" color="text.disabled" sx={{ mb: 2, wordBreak: 'break-all' }}>
              Reference: {sessionId}
            </Typography>
          )}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mt: 2 }}>
            {isAuthenticated && (
              <Button
                variant="contained"
                size="large"
                startIcon={<EventNote />}
                onClick={() => navigate('/bookings')}
                fullWidth
              >
                My bookings
              </Button>
            )}
            {!isAuthenticated && (
              <Button
                variant="contained"
                size="large"
                startIcon={<Login />}
                onClick={() => navigate('/login')}
                fullWidth
              >
                Sign in to view bookings
              </Button>
            )}
            <Button
              variant="outlined"
              size="large"
              startIcon={<Home />}
              onClick={() => navigate('/guest')}
              fullWidth
            >
              Continue as guest
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default OfflinePaymentSuccess;
